import React from "react";
import { Auth0Feature } from "./auth0-feature";

export const Auth0Features = () => {
  const featuresList = [
    {
      id: "raskt",
      title: "Raskt og enkelt",
      description:
        "Sett opp din Google Tag Manager Server container på under 5 minutter. Følg vår offisielle guide for 1-2-3 setup.",
      icon: "https://imagedelivery.net/cQwdhF-H4tUVK8IxRhv2kQ/98c24b5e-d8bb-4000-c8de-77999a435500/public",
    },
    {
      id: "sikkert",
      title: "Sikkert",
      description:
        "Vår løsning er bygget på det seneste innenfor sikkerhet og personvern. Din datasikkerhet er vår største prioritet.",
      icon: "https://imagedelivery.net/cQwdhF-H4tUVK8IxRhv2kQ/1fe7e9ab-887d-4f20-f06a-fd6306298a00/public",
    },
    {
      id: "skalerbart",
      title: "Skalerbart",
      description:
        "Velg selv planen som passer deg og oppgrader automatisk når du når din månedlige grense. Ikke mist verdifull data.",
      icon: "https://imagedelivery.net/cQwdhF-H4tUVK8IxRhv2kQ/28f40e6a-49b1-434b-1fa6-fac357432700/public",
    },
    {
      id: "gdpr",
      title: "GDPR- og norsk ekomlov-kompatibel",
      description:
        "Vår løsning er helnorsk og ingen data forlater hverken Norge eller EU.",
      icon: "https://imagedelivery.net/cQwdhF-H4tUVK8IxRhv2kQ/fa95c24d-cc3e-4497-c08c-8c95218c5800/public",
    },
  ];

  return (
    <div className="fjelldigi-features">
      <h2 className="fjelldigi-features__title">
        Hvorfor velge Fjell Hosting?
      </h2>
      <div className="fjelldigi-features__grid">
        {featuresList.map((feature) => (
          <Auth0Feature
            key={feature.id}
            title={feature.title}
            description={feature.description}
            icon={feature.icon}
          />
        ))}
      </div>
    </div>
  );
};
